import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Heart, Users, Handshake, Sparkles } from 'lucide-react';
export function TalentWithPurpose() {
  const missions = [{
    icon: <Globe className="w-6 h-6" data-id="element-249" />,
    text: 'Expanding opportunities for Latin American talent'
  }, {
    icon: <Users className="w-6 h-6" data-id="element-250" />,
    text: 'Promoting female leadership'
  }, {
    icon: <Heart className="w-6 h-6" data-id="element-251" />,
    text: 'Supporting inclusive hiring'
  }, {
    icon: <Handshake className="w-6 h-6" data-id="element-252" />,
    text: 'Building long-term partnerships'
  }, {
    icon: <Sparkles className="w-6 h-6" data-id="element-253" />,
    text: 'Creating positive impact through every placement'
  }];
  return <section className="py-24 bg-navy relative overflow-hidden" data-id="element-254">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5 mix-blend-overlay" data-id="element-255"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-256">
        <div className="text-center mb-16" data-id="element-257">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold text-white" data-id="element-258">
            Recruiting With Purpose
          </motion.h2>
        </div>

        <div className="flex flex-wrap justify-center gap-6" data-id="element-259">
          {missions.map((mission, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white/10 backdrop-blur-md border border-white/10 rounded-full px-6 py-4 flex items-center gap-4 hover:bg-white/20 transition-colors" data-id="element-260">
              <div className="text-pink" data-id="element-261">{mission.icon}</div>
              <span className="text-white font-medium" data-id="element-262">{mission.text}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}